import React from "react";

const Blog = () => {
  return (
    <div className="container">
      <div className="border m-3 p-3">
        <h2>Difference between javascript and nodejs</h2>
        <p>
        JavaScript হল একটি সাধারণ প্রোগ্রামিং ভাষা যা যেকোনো ব্রাউজারে JavaScript ইঞ্জিন চালায়। যেখানে node.js হল একটি জাভাস্ক্রিপ্ট প্রোগ্রামিং ভাষার জন্য একটি interpreter  বা চলমান পরিবেশ যা অনেক বাড়াবাড়ি ধারণ করে, এটির জন্য লাইব্রেরি প্রয়োজন যা ভাল ব্যবহারের জন্য জাভাস্ক্রিপ্ট প্রোগ্রামিং থেকে সহজেই অ্যাক্সেস করা যেতে পারে।
        </p>
        <p>
        Spider monkey (FireFox), JavaScript Core (Safari), V8 (Google Chrome)  এর মতো যেকোনো ইঞ্জিনে জাভাস্ক্রিপ্ট চলছে। সুতরাং জাভাস্ক্রিপ্ট প্রোগ্রামিং লিখতে খুব সহজ, এবং যেকোনো চলমান পরিবেশ মানে সঠিক ব্রাউজার। যেখানে নোড জেএস শুধুমাত্র V8 ইঞ্জিন সমর্থন করে, যা ক্রোম স্পেসিফিক গুগল করে।
        </p>
      </div>
      <div className="border m-3 p-3">
        <h2>
        When should you use nodejs and when should you use mongodb
        </h2>
        <p>node.js প্রাথমিকভাবে নন-ব্লকিং, ইভেন্ট-চালিত সার্ভারগুলির জন্য ব্যবহৃত হয়, এর একক-থ্রেড প্রকৃতির কারণে। এটি প্রথাগত ওয়েব সাইট এবং ব্যাক-এন্ড API পরিষেবাগুলির জন্য ব্যবহৃত হয়, তবে বাস্তব-সময়, পুশ-ভিত্তিক আর্কিটেকচারের কথা মাথায় রেখে ডিজাইন করা হয়েছিল।

        আর MongoDB-এর মতো NoSQL ডাটাবেসগুলি একটি ভাল পছন্দ যখন আপনার ডেটা ডকুমেন্ট-কেন্দ্রিক হয় এবং একটি রিলেশনাল ডাটাবেসের স্কিমার সাথে ভালভাবে ফিট করে না, যখন আপনাকে বিশাল স্কেল মিটমাট করতে হবে, যখন আপনি দ্রুত প্রোটোটাইপ করছেন এবং কয়েকটি অন্যান্য ক্ষেত্রে ব্যবহার করেন।
        </p>
        <p>
        MongoDB হল NoSQL ডাটাবেস যা document ভিত্তিক। এটি JSON document হিসাবে ডেটা উপস্থাপন করে। এটি স্টোর ডেটার জন্য ব্যবহৃত  হয়। অন্যদিকে node.js একটি জাভাস্ক্রিপ্ট রানটাইম পরিবেশ। এটি আসলে জাভাস্ক্রিপ্টকে সার্ভারের বাইরে চলতে সাহায্য করে। এটি সার্ভার সাইড ডেভেলপমেন্টে ব্যবহৃত হয়।
        </p>
        <p>মূলকথা হল MongoDB হল একটি ডাটাবেস যেখানে আমরা ডেটা সঞ্চয় করতে পারি এবং NodeJS আমাদের ক্লায়েন্ট সাইটটিকে এর সার্ভার সাইটের মাধ্যমে ডাটাবেসের সাথে সংযোগ করতে সাহায্য করে।</p>
      </div>
      <div className="border m-3 p-3">
        <h2>Differences between sql and nosql databases.</h2>
        <p>
        SQL ডেটাবেসগুলিকে প্রাথমিকভাবে রিলেশনাল ডেটাবেস (RDBMS) বলা হয়.এই ডাটাবেসের স্থির বা স্থির বা পূর্বনির্ধারিত স্কিমা আছে।এই ডাটাবেস শ্রেণীবদ্ধ ডেটা সঞ্চয়ের জন্য উপযুক্ত নয়।এই ডাটাবেসগুলি জটিল প্রশ্নের জন্য সবচেয়ে উপযুক্ত।উল্লম্বভাবে মাপযোগ্য।ACID  অনুসরণ করে।

        </p>
        <p>NoSQL ডাটাবেসকে প্রাথমিকভাবে অ-রিলেশনাল বা বিতরণ করা ডাটাবেস বলা হয়.তাদের dynamic স্কিমা আছে।এই ডাটাবেসগুলি শ্রেণীবদ্ধ ডেটা সঞ্চয়ের জন্য সবচেয়ে উপযুক্ত।এই ডাটাবেসগুলি জটিল প্রশ্নের জন্য এত ভাল নয়।অনুভূমিকভাবে মাপযোগ্য।
         CAP (consistency, availability, partition tolerance) অনুসরণ করে।
        </p>
      </div>
    </div>
  );
};

export default Blog;
